import { Button, Card, Space, Statistic, Tag } from "antd";
import { useTranslation } from "react-i18next";
import type { QueueStatus } from "../types";

interface QueueCardProps {
	status: QueueStatus;
	onShowFailed: (name: string) => void;
}

const SANOQ_KALITLARI: (keyof QueueStatus & string)[] = [
	"waiting",
	"active",
	"delayed",
	"completed",
	"failed",
];

/**
 * Bitta navbatning holati.
 *
 * ⚠️⚠️ **`paused` — SANOQ EMAS, BAYROQ** (backend `jobs.schemas.ts`).
 * BullMQ 6 da `paused` alohida job ro'yxati emas, shuning uchun u
 * oltinchi raqam sifatida emas, YORLIQ sifatida ko'rsatiladi — raqam
 * doim `0` bo'lib, «to'xtatilgan navbat» holatini butunlay yashirardi.
 */
export function QueueCard({ status, onShowFailed }: QueueCardProps) {
	const { t } = useTranslation("jobs");
	const xatoBor = status.failed > 0;

	return (
		<Card
			size="small"
			title={
				<Space>
					<span>{status.name}</span>
					{status.paused ? <Tag color="orange">{t("queueCard.paused")}</Tag> : null}
				</Space>
			}
			// ⚠️ Xatoli navbat DARHOL ko'rinishi kerak — u operatsion signal.
			style={xatoBor ? { borderColor: "var(--ant-color-error)" } : undefined}
			extra={
				xatoBor ? (
					<Button size="small" danger onClick={() => onShowFailed(status.name)}>
						{t("queueCard.showFailed")}
					</Button>
				) : null
			}
		>
			<Space size="large" wrap>
				{SANOQ_KALITLARI.map((key) => (
					<Statistic
						key={key}
						title={t(`queueCard.counts.${key}`)}
						value={Number(status[key])}
						styles={
							key === "failed" && xatoBor
								? { content: { color: "var(--ant-color-error)" } }
								: undefined
						}
					/>
				))}
			</Space>
		</Card>
	);
}
